export const mutations = {
    UPDATE_SIDEBAR_WIDTH(state, width) {
        state.sidebarWidth = width;
    },
    UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
        state.sidebarItemsMin = val;
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
        state.reduceButton = val;
    },
    TOGGLE_CONTENT_OVERLAY(state, val) {
        state.bodyOverlay = val;
    },
    TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
        state.isSidebarActive = value;
    },
    UPDATE_WINDOW_BREAKPOINT(state, val) {
        state.breakpoint = val;
    },
    UPDATE_STARRED_PAGE(state, payload) {
        const index = state.navbarSearchAndPinList.data.findIndex((item) => item.index == payload.index);
        state.navbarSearchAndPinList.data[index].highlightAction = payload.val;
    },
    UPDATE_TOKEN(state, token) {
        state.authToken = token;
    },
    UPDATE_USER(state, user) {
        state.currentUser = user;
    },
    UPDATE_DATE_RANGE(state, payload) {
        state.daterange.startDate = payload.startDate;
        state.daterange.endDate = payload.endDate;
    },
    UPDATE_RELATORIO_COMISSOES(state, payload) {
        state.relatorioComissoes.startDate = payload.startDate;
        state.relatorioComissoes.endDate = payload.endDate;
        state.relatorioComissoes.idUser = payload.idUser;
        state.relatorioComissoes.data = payload.data;
    },
    UPDATE_DASHBOARD(state, payload) {
        state.dashboard.date = payload.date;
        state.dashboard.idUser = payload.idUser;

        if (payload.comissoes) {
            state.dashboard.comissoes = payload.comissoes;
        }

        if (payload.tickets) {
            state.dashboard.tickets = payload.tickets;
        }

        if (payload.map) {
            state.dashboard.map = payload.map;
        }
    }
};
